// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MV-z","inlineTitle":"NV-z","sponsoredAdsWrapper":"OV-z","marketplaceRecosWrapper":"PV-z"};